// Like/Reply Button
NP.Button = (function( $ ) {
	var tplParser = NP.ns( 'Util.tplParser' );

	NP.timeline.on( 'mouseenter', '.wrap_feed li', function() {
		$( this ).find( 'a' ).show();
	});
	NP.timeline.on( 'mouseleave', '.wrap_feed li', function() {
		$( this ).find( 'a' ).hide();
	});

	return {
		setUI : function( article ) {
			if ( article.orgActType === 'LIKE_POST' || ( article.hasLike === 'Y' && article.hasReply === 'Y' ) ) {
				return ( tplParser( NP.tmpl.button ) )( article );
			}

			return '';
		},
		mProfile : function( data ) {
			var data = data.miniProfile;
			var html = '';

			if ( NP.dt.v !== '' && NP.dt.v === data.profile.playncAcctId ) {
				// REPAIR - 20150812. '/$!/my/profile/modify' -> '/my/profile/modify'
				html = '<a href="' + NP.prflUri( NP.dt.v ) + '/my/profile/modify" class="btn_connect confirm">프로필 수정</a>';
			} else {
				if ( data.friendReference && data.friendReference.receivedProposals[ 0 ] ) { // 받은 NC친구 신청
					var _data = data.friendReference.receivedProposals[ 0 ];
					if (_data.privacy_relationship == "deny" || _data.privacy_relationship == "denyby" || _data.privacy_relationship == "deny,denyby") {
						html += '<a class="js_btnFriend btn_connect2 bluish3" onclick="modal.show({txt:\'요청 정보가 없습니다.\'});">NC친구신청수락</a> ';
					}else{
						html += '<a class="js_btnFriend btn_connect2 bluish3" left-btn="1" a-type="friend_accept_btn" data-current="3" friend-acc-id="' + data.profile.playncAcctId + '" proposal-id="' + data.friendReference.receivedProposals[ 0 ].proposal_id + '" friend-alias="" friend-action-type="1" thumb-img-url="' + NP.sfile( data.profile.playncAcctId ) + '" thumb-user-name="' + data.profile.userName + '" thumb-prfurl="' + data.profile.prflUri + '" thumb-acc-id="' + data.profile.playncAcctId + '">NC친구신청수락</a> ';
					}
				} else if ( data.friendReference && data.friendReference.sentProposals[ 0 ] ) { // 보낸 NC친구 신청
					html += '<a class="js_btnFriend btn_connect2 gray2" left-btn="1" a-type="friend_propose_btn" data-current="1" friend-acc-id="' + data.profile.playncAcctId + '" proposal-id="' + data.friendReference.sentProposals[ 0 ].proposal_id + '" friend-alias="" friend-action-type="1" thumb-img-url="' + NP.sfile( data.profile.playncAcctId ) + '" thumb-user-name="' + data.profile.userName + '" thumb-prfurl="' + data.profile.prflUri + '" thumb-acc-id="' + data.profile.playncAcctId + '">NC친구신청중</a> ';
				} else if ( data.friendReference.friendRelation === 'FRIEND' || data.friendReference.friendRelation === 'BLOCKED' || data.friendReference.friendRelation === 'BLOCKING' ) { // NC친구
					html += '<a class="js_btnFriend btn_connect2 bluish2" left-btn="1" a-type="friend_propose_btn" data-current="2" friend-acc-id="' + data.profile.playncAcctId + '" proposal-id="" friend-alias="" friend-action-type="1" thumb-img-url="' + NP.sfile( data.profile.playncAcctId ) + '" thumb-user-name="' + data.profile.userName + '" thumb-prfurl="' + data.profile.prflUri + '" thumb-acc-id="' + data.profile.playncAcctId + '">NC친구</a> ';
				} else { // NC친구신청
					if (data.friendReference.privacyRelationship == "deny") {
						html += '<a class="btn_connect2 bluish1" onclick="modal.show({txt:\'현재 차단한 사용자입니다\'});">NC친구신청</a> ';
					}else{
						html += '<a class="js_btnFriend btn_connect2 bluish1" left-btn="1" a-type="friend_propose_btn" data-current="0" friend-acc-id="' + data.profile.playncAcctId + '" proposal-id="" friend-alias="" friend-action-type="1" thumb-img-url="' + NP.sfile( data.profile.playncAcctId ) + '" thumb-user-name="' + data.profile.userName + '" thumb-prfurl="' + data.profile.prflUri + '" thumb-acc-id="' + data.profile.playncAcctId + '">NC친구신청</a> ';
					}
				}

				if ( data.friendReference.followRelation === 'FOLLOWEE' || data.friendReference.followRelation === 'FOLLOWEE_FOLLOWER' ) {
					html += '<a class="js_btnFollow btn_connect complete" left-btn="1" follow-acc-id="' + data.profile.playncAcctId + '" data-current="1" follow-action-type="1">구독중</a>';
				} else {
					html += '<a class="js_btnFollow btn_connect" left-btn="1" follow-acc-id="' + data.profile.playncAcctId + '" data-current="0" follow-action-type="1">구독</a>';
				}
			}

			return html;
		}
	};
}( jQuery ));
